import { render } from "./PoliticalCompass.vue?vue&type=template&id=9af11786&scoped=true"
import script from "./PoliticalCompass.vue?vue&type=script&lang=js"
export * from "./PoliticalCompass.vue?vue&type=script&lang=js"

import "./PoliticalCompass.vue?vue&type=style&index=0&id=9af11786&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9af11786"

export default script